import marked from 'marked';

export const mark = (value: string) => {
  if (value && value.length > 0) {
    return {__html: marked(value)};
  }
  return {__html: value};
};
